import { ref } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2931bf72"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  class: "filter-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, null, -1));
const _hoisted_4 = {
  class: "right"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  style: {
    "margin": "0",
    "padding-left": "20px"
  }
}, [/*#__PURE__*/_createElementVNode("li", null, "销售额(USD)=付费下载销售总金额（美元）"), /*#__PURE__*/_createElementVNode("li", null, "总收入(USD)=付费下载参与分成后的实际收入（美元）"), /*#__PURE__*/_createElementVNode("li", null, "销售额(CNY)=付费下载销售总金额（人民币）"), /*#__PURE__*/_createElementVNode("li", null, "总收入(CNY)=付费下载参与分成后的实际收入（人民币）"), /*#__PURE__*/_createElementVNode("li", null, "下载量=实际付费数量"), /*#__PURE__*/_createElementVNode("li", null, "退款金额(USD)=退款成功的金额（美元）"), /*#__PURE__*/_createElementVNode("li", null, "退款金额(CNY)=退款成功的金额（人民币）"), /*#__PURE__*/_createElementVNode("li", null, "退款订单数=退款成功的订单数")], -1));
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
import FilterColumn from '@/views/paidDownloads/paidKanban/components/FilterColumn.vue';
import { message } from 'ant-design-vue';
import { basicColumns } from '@/views/paidDownloads/paidKanban/components/data';
import { awaitWrap, OK, reportEvent } from '@/common';
import { exportPaidDimensionChart, queryDimensionChart } from '@/api/paidApi';
export default /*#__PURE__*/_defineComponent({
  __name: 'TableContent',
  setup(__props, {
    expose
  }) {
    const dataSource = ref([]),
      pageTotal = ref(0),
      pageIndex = ref(1),
      pageSize = ref(10),
      columns = ref([{
        title: '时间',
        dataIndex: 'dt',
        key: 'dt',
        sorter: true
      }, {
        title: '产品名',
        dataIndex: 'appName',
        key: 'appName'
      }]),
      dimensionTitleList = ref([]),
      indexList = ref([]),
      searchForm = ref({}),
      loading = ref(false),
      exportLoading = ref(false),
      dateSort = ref(null),
      usdSalesSort = ref(null),
      cnySalesSort = ref(null),
      usdRevenueSort = ref(null),
      cnyRevenueSort = ref(null),
      orderAmountSort = ref(null);
    const getColumn = col => {
        let arr = [];
        col.list.forEach(item => {
          arr = [...arr, ...item.value];
        });
        indexList.value = arr;
        changeColumns();
      },
      currentPageSizeChange = (page, pageS) => {
        pageIndex.value = page;
        pageSize.value = pageS;
        getData();
      },
      getData = async (searchObj = {}) => {
        var _Object$keys, _columns$value;
        let startTime = new Date().getTime();
        if ((_Object$keys = Object.keys(searchObj)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
          searchForm.value = searchObj;
        }
        let params = {
          pageNum: pageIndex.value,
          pageSize: pageSize.value
        };
        if (dateSort.value !== null) params = {
          ...params,
          timeSort: dateSort.value
        };
        if (usdSalesSort.value !== null) params = {
          ...params,
          usdAmountSort: usdSalesSort.value
        };
        if (cnySalesSort.value !== null) params = {
          ...params,
          cnyAmountSort: cnySalesSort.value
        };
        if (usdRevenueSort.value !== null) params = {
          ...params,
          usdRevenueSort: usdRevenueSort.value
        };
        if (cnyRevenueSort.value !== null) params = {
          ...params,
          cnyRevenueSort: cnyRevenueSort.value
        };
        if (orderAmountSort.value !== null) params = {
          ...params,
          orderAmountSort: orderAmountSort.value
        };
        Object.keys(searchForm.value).forEach(item => {
          var _searchForm$value$ite;
          if (searchForm.value[item] && (_searchForm$value$ite = searchForm.value[item]) !== null && _searchForm$value$ite !== void 0 && _searchForm$value$ite.length) {
            params = {
              ...params,
              [item]: searchForm.value[item]
            };
          }
        });
        let indicatorsMap = {};
        (_columns$value = columns.value) === null || _columns$value === void 0 || _columns$value.map(item => {
          return indicatorsMap = {
            ...indicatorsMap,
            [item.dataIndex]: item.title
          };
        });
        params = {
          ...params,
          dimensionList: Object.keys(indicatorsMap)
        };
        loading.value = true;
        const [err, data] = await awaitWrap(queryDimensionChart(params));
        if (data && data.code === OK) {
          var _data$data, _data$data2;
          pageTotal.value = (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.total;
          dataSource.value = (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.list;
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '付费下载看板',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'succeed'
            }
          });
        }
        if (err) {
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '付费下载看板',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'failed'
            }
          });
        }
        loading.value = false;
      },
      searchData = (searchObj = {}) => {
        pageIndex.value = 1;
        getData(searchObj);
      },
      exportExcel = async () => {
        var _columns$value2;
        if (!dataSource.value.length) return false;
        let params = {};
        if (dateSort.value !== null) {
          params = {
            ...params,
            timeSort: dateSort.value
          };
        }
        Object.keys(searchForm.value).forEach(item => {
          var _searchForm$value$ite2;
          if (searchForm.value[item] && (_searchForm$value$ite2 = searchForm.value[item]) !== null && _searchForm$value$ite2 !== void 0 && _searchForm$value$ite2.length) {
            params = {
              ...params,
              [item]: searchForm.value[item]
            };
          }
        });
        let indicatorsMap = {};
        (_columns$value2 = columns.value) === null || _columns$value2 === void 0 || _columns$value2.map(item => {
          return indicatorsMap = {
            ...indicatorsMap,
            [item.dataIndex]: item.title
          };
        });
        params = {
          ...params,
          dimensionList: Object.keys(indicatorsMap)
        };
        if (dateSort.value !== null) params = {
          ...params,
          timeSort: dateSort.value
        };
        if (usdSalesSort.value !== null) params = {
          ...params,
          usdAmountSort: usdSalesSort.value
        };
        if (cnySalesSort.value !== null) params = {
          ...params,
          cnyAmountSort: cnySalesSort.value
        };
        if (usdRevenueSort.value !== null) params = {
          ...params,
          usdRevenueSort: usdRevenueSort.value
        };
        if (cnyRevenueSort.value !== null) params = {
          ...params,
          cnyRevenueSort: cnyRevenueSort.value
        };
        if (orderAmountSort.value !== null) params = {
          ...params,
          orderAmountSort: orderAmountSort.value
        };
        try {
          var _searchForm$value, _searchForm$value2, _searchForm$value3;
          exportLoading.value = true;
          let blob = new Blob([await exportPaidDimensionChart(params)], {
            type: 'application/vnd.ms-excel'
          });
          let url = window.URL.createObjectURL(blob);
          let downloadElement = document.createElement('a');
          downloadElement.href = url;
          downloadElement.download = (_searchForm$value = searchForm.value) !== null && _searchForm$value !== void 0 && _searchForm$value.startDate ? `付费下载_${(_searchForm$value2 = searchForm.value) === null || _searchForm$value2 === void 0 ? void 0 : _searchForm$value2.startDate}-${(_searchForm$value3 = searchForm.value) === null || _searchForm$value3 === void 0 ? void 0 : _searchForm$value3.endDate}.xlsx` : `付费下载.xlsx`;
          downloadElement.click();
          URL.revokeObjectURL(downloadElement.href);
          exportLoading.value = false;
          message.success('导出成功');
          reportEvent({
            eventName: 'element_use',
            properties: {
              'ui_name': '付费下载看板',
              'element_name': '导出'
            }
          });
        } catch (e) {}
      },
      changeColumns = () => {
        var _Object$keys2;
        let arr = ['dt', 'appName', ...dimensionTitleList.value, ...indexList.value];
        columns.value = basicColumns.filter(item => arr.includes(item.dataIndex));
        if ((_Object$keys2 = Object.keys(searchForm.value)) !== null && _Object$keys2 !== void 0 && _Object$keys2.length) {
          getData();
        }
      },
      changeSort = (pagination, filters, sorter) => {
        dateSort.value = null;
        usdSalesSort.value = null;
        cnySalesSort.value = null;
        usdRevenueSort.value = null;
        cnyRevenueSort.value = null;
        orderAmountSort.value = null;
        switch (sorter.columnKey) {
          case 'dt':
            dateSort.value = !sorter.order ? null : sorter.order === 'ascend' ? 0 : 1;
            break;
          case 'usdAmount':
            usdSalesSort.value = !sorter.order ? null : sorter.order === 'ascend' ? 0 : 1;
            break;
          case 'cnyAmount':
            cnySalesSort.value = !sorter.order ? null : sorter.order === 'ascend' ? 0 : 1;
            break;
          case 'usdRevenue':
            usdRevenueSort.value = !sorter.order ? null : sorter.order === 'ascend' ? 0 : 1;
            break;
          case 'cnyRevenue':
            cnyRevenueSort.value = !sorter.order ? null : sorter.order === 'ascend' ? 0 : 1;
            break;
          case 'orderAmount':
            orderAmountSort.value = !sorter.order ? null : sorter.order === 'ascend' ? 0 : 1;
            break;
          default:
            break;
        }
        pageIndex.value = 1;
        getData();
      };
    expose({
      searchData
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_tooltip, null, {
        title: _withCtx(() => [_hoisted_5]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "questionMark",
          "class-name": "market-icon"
        })]),
        _: 1
      }), _createVNode(FilterColumn, {
        onGetColumn: getColumn
      }), _createVNode(_component_a_button, {
        type: "primary",
        class: "export-btn",
        onClick: exportExcel,
        loading: exportLoading.value
      }, {
        default: _withCtx(() => [_createTextVNode("导出")]),
        _: 1
      }, 8, ["loading"])])]), _createVNode(_component_a_table, {
        columns: columns.value,
        "data-source": dataSource.value,
        bordered: "",
        scroll: {
          x: 150 * columns.value.length
        },
        pagination: false,
        loading: loading.value,
        onChange: changeSort
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _ref;
          return [column.dataIndex === 'firstBuyerRatio' ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString((_ref = (record === null || record === void 0 ? void 0 : record.firstBuyerRatio) * 100) === null || _ref === void 0 ? void 0 : _ref.toFixed(2)) + "%", 1)) : _createCommentVNode("", true), column.dataIndex === 'prodName' ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(record !== null && record !== void 0 && record.prodName ? record === null || record === void 0 ? void 0 : record.prodName : record === null || record === void 0 ? void 0 : record.sku), 1)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["columns", "data-source", "scroll", "loading"]), _createVNode(_component_a_pagination, {
        total: pageTotal.value,
        current: pageIndex.value,
        "onUpdate:current": _cache[0] || (_cache[0] = $event => pageIndex.value = $event),
        "show-size-changer": "",
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        onChange: currentPageSizeChange
      }, null, 8, ["total", "current", "page-size"])]);
    };
  }
});